"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
/**
 * Apply Status types from StatusConstantsObj and export them as an enum-like object.
 */
exports.Status = javelin_exports_1.javelin.data.model.Status;
//# sourceMappingURL=status.js.map